import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import {
  commitResponseSchema,
  validateResponseSchema,
  type CommitResult,
  type ImportPlan,
  type ImportRowInput,
} from './types';

// Previsualización (sin escribir) y confirmación de la migración (spec 2026-10-14 §2).
// Al confirmar se refrescan la Lista Maestra y los catálogos (procesos y tipos nuevos).

const BASE = '/api/v1/quality/master-list/import';

export interface ImportBody {
  source: string;
  rows: ImportRowInput[];
}

export function useValidateImport(): UseMutationResult<ImportPlan, Error, ImportBody> {
  const api = useApi();
  return useMutation({
    mutationFn: async (body) =>
      validateResponseSchema.parse(await api.post<unknown>(`${BASE}/validate`, body)).data,
  });
}

export function useCommitImport(): UseMutationResult<CommitResult, Error, ImportBody> {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) =>
      commitResponseSchema.parse(await api.post<unknown>(`${BASE}/commit`, body)).data,
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['master-list'] }),
        qc.invalidateQueries({ queryKey: ['quality-catalogs'] }),
      ]);
    },
  });
}
